import React from 'react';
import {
	Box,
	Typography,
	IconButton,
	TextField,
	Tooltip,
	Divider,
	alpha,
	useTheme,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SectionHeader from './SectionHeader';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const EditableTextSection = ({
	icon,
	title,
	value,
	placeholder,
	isEditing,
	onToggleEdit,
	onChange,
	onConfirm,
}) => {
	const theme = useTheme();

	return (
		<Box sx={surfaceCard(theme)}>
			<SectionHeader
				icon={icon}
				title={title}
				action={
					<Tooltip title={isEditing ? 'Save' : `Edit ${title.toLowerCase()}`}>
						<IconButton
							size="small"
							onMouseDown={onToggleEdit}
							sx={{
								color: isEditing ? 'primary.main' : 'text.secondary',
								bgcolor: isEditing
									? (t) => alpha(t.palette.primary.main, 0.12)
									: 'transparent',
								'&:hover': {
									bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
									color: 'primary.main',
								},
							}}
						>
							<EditIcon sx={{ fontSize: 18 }} />
						</IconButton>
					</Tooltip>
				}
			/>
			<Divider sx={{ opacity: 0.6 }} />
			<Box sx={{ px: { xs: 2, sm: 2.5 }, py: { xs: 2, sm: 2.5 } }}>
				{isEditing ? (
					<TextField
						fullWidth
						multiline
						value={value || ''}
						minRows={4}
						maxRows={12}
						autoFocus
						placeholder={placeholder}
						onChange={(e) => onChange(e.target.value)}
						onBlur={(e) => onConfirm(e.target.value)}
						sx={{
							'& .MuiOutlinedInput-root': {
								borderRadius: 2,
								bgcolor: (t) =>
									t.palette.mode === 'dark'
										? alpha(t.palette.common.white, 0.04)
										: alpha(t.palette.common.black, 0.02),
							},
						}}
					/>
				) : (
					<Typography
						variant="body2"
						sx={{
							whiteSpace: 'pre-wrap',
							lineHeight: 1.75,
							color: value ? 'text.primary' : 'text.secondary',
							fontStyle: value ? 'normal' : 'italic',
						}}
					>
						{value || placeholder}
					</Typography>
				)}
			</Box>
		</Box>
	);
};

export default EditableTextSection;
